<template>
  <v-container grid-list-md>
    <div class="text-xs-center mt-5">
      <h1>ActNotify</h1>
    </div>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap="">
        <v-flex xs12 sm6 offset-sm3 mt-5>
          <br>
          <v-card>
            <form @submit.prevent="login({username, password})">
              <v-card-text>
                <v-alert :value="showError">Email/Password are incorrect.</v-alert>
                <v-flex md12>
                  <v-text-field required v-model="username" name="email" label="Email"/>
                  <v-text-field
                    v-model="password"
                    :append-icon="show ? 'visibility_off' : 'visibility'"
                    :type="show ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    required
                    @click:append="show = !show"
                  />
                  <div>
                    <v-btn flat small class="forgot">Forgot Password</v-btn>
                  </div>
                </v-flex>
              </v-card-text>
              <v-card-actions style="clear: both;">
                <v-btn color="blue" block dark type="submit">Sign In</v-btn>
              </v-card-actions>
            </form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>ƒ

<script>
import { mapActions } from 'vuex';
import * as Sentry from '@sentry/browser';

export default {
  name: 'Login',
  props: {
    msg: String
  },
  data() {
    return {
      showError: false,
      show: false,
      username: '',
      password: '',
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => "The email and password you entered don't match"
      }
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch('auth/login', {
          email: this.username,
          password: this.password
        })
        .then(() => {
          this.showError = false;
          this.$router.push('/');
        })
        .catch(e => {
          console.log(e);
          this.showError = true;
          Sentry.captureException(e);
          return e;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.v-card__text,
.v-card__title,
.v-card__actions {
  padding-left: 32px;
  padding-right: 32px;
}
.v-card__actions {
  padding-bottom: 32px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.forgot {
  float: right;
  margin: -15px 0 25px 0;
}
</style>
